<script>

    import {createEventDispatcher, onDestroy} from "svelte";
    import {get} from "svelte/store";
    import CartItem from "./CartItem.svelte";
    import {cartItemsStore, cartTotalStore} from "./cart-store.js";
    import {menuStore, publishConfigStore, tenantKeyStore} from "../core/app-store.js";
    import {orderConfigStore} from "../orders/orders-store.js";
    import {screensStore} from "../core/screens-manager.js";
    import {deliveryOpenStore, checkOpenState} from "../core/time.js";
    import TotalBlock from "../components/TotalBlock.svelte";
    import RecommendationsBlock from "../components/RecommendationsBlock.svelte";
    import YourFavoritesBlock from "../components/YourFavoritesBlock.svelte";
    import CartOrderButton from "./CartOrderButton.svelte";
    import Button from "../components/Button.svelte";
    import {getRecommendedItems} from "../core/get-recommended-items.js";
    import {getFavoriteItems} from "../core/get-favorite-items.js";
    import { t } from '../core/i18n/language-store';

    import {openOrderScreen} from "../core/screens-manager.js";
    import {reachGoal} from "../core/ecommerce.js";
    import {confirmOrder} from "./cart-store.js";

    const orderConfig = get(orderConfigStore);

    const dispatch = createEventDispatcher();

    export let showTotal = true;

    let recommended = [];
    let favorites = [];

    function refreshRecommendations () {
        const menu = get(menuStore);
        recommended = getRecommendedItems(menu);
        favorites = getFavoriteItems(menu);
    }

    function closeScreen () {
        dispatch('close');
    }

    function confirmOrderHandler(e) {
        confirmOrder(e.detail);
        openOrderScreen();
        reachGoal('OPEN_ORDER_FORM');
    }

    const storeSubscriptions = [
        screensStore.subscribe(x => {
            if (x.cartOpened) {
                checkOpenState();
                refreshRecommendations();
            }
        }),

        cartItemsStore.subscribe(() => {
            refreshRecommendations();
        })
    ];

    onDestroy(() => {
        for (let i = 0; i < storeSubscriptions.length; i++){
            storeSubscriptions[i]();
        }
    });

</script>

<style>

    .recommendations-section {}

    .screen-header svg {
        color: var(--screen-text-color);
    }
    .screen-header small {
        opacity: .7;
    }

    ul {
        display: flex;
        flex-direction: column;
        gap: 1.25rem;
        margin-bottom: .5rem;
    }
    li {}
    li:last-child.separator {
        display: none;
    }
    li.no-data {
        text-align: center;
        padding: 2rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }
    li.no-data button {
        padding: 0.75rem 1.5rem;
        border: none;
        border-radius: 1.5rem;
        font-size: inherit;
        font-family: inherit;
        font-weight: 600;
        letter-spacing: .5px;
        color: var(--price-item-font-color);
        background: var(--success-bg-color);
        transition: background-color .2s ease-in-out;
        box-shadow: 0 6px 9px 4px rgb(0 0 0 / 8%);
    }
    .pb-2 {
        padding-bottom: 2rem;
    }
</style>

{#if ($screensStore.cartOpened)}

    <div class="layer-cart screen-backdrop"></div>
    <button class="screen-close-button pointer" on:click={closeScreen}>
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Cross">
            <path d="M20 20L4 4m16 0L4 20"/>
        </svg>
    </button>

    <div class="desktop-screen layer-cart screen-content slide-up-animation--centered">
        <div class="screen-header">
            <span>
                <h1>{$t('cart.title')}</h1>
            </span>


        </div>

        <ul>
            {#each $cartItemsStore as item, i}
            <li>
                <CartItem item={item}
                          publishConfig={$publishConfigStore}
                          tenantKey={$tenantKeyStore}>
                </CartItem>
            </li>
            <li class="separator"></li>
            {/each}

            {#if ($cartItemsStore.length === 0)}
                <li class="no-data">
                    <span>{$t('cart.empty')}</span>
                    <Button type="secondary" on:clicked={closeScreen} label={$t('cart.openMenu')}></Button>
                </li>
            {/if}
        </ul>

        {#if (showTotal)}
            <div style="padding: 1rem 0;">
                <TotalBlock hideTotal={true} hideDelivery={true}></TotalBlock>
            </div>
        {/if}

        <div class="screen-footer">

            <CartOrderButton
                    cartItemsStore={$cartItemsStore}
                    orderConfigStore={$orderConfigStore}
                    cartTotalStore={$cartTotalStore}
                    deliveryOpenStore={$deliveryOpenStore}
                    publishConfigStore={$publishConfigStore}
                    on:confirmOrder={confirmOrderHandler}
                    on:close={closeScreen}>
            </CartOrderButton>

            <div class="recommendations-section">
                <RecommendationsBlock recommended={recommended}></RecommendationsBlock>
            </div>

            <YourFavoritesBlock favorites={favorites}></YourFavoritesBlock>

        </div>

        <!-- SECOND TOTAL AND CART ORDER BUTTON -->
        {#if (recommended?.length > 0 || favorites?.length > 0)}
            <hr class="separator full-width">
            <div class="pb-2">
                {#if (showTotal)}
                    <div style="padding: 1rem 0 2rem 0;">
                        <TotalBlock hideTotal={true} hideDelivery={true}></TotalBlock>
                    </div>
                {/if}
                <CartOrderButton
                        cartItemsStore={$cartItemsStore}
                        orderConfigStore={$orderConfigStore}
                        cartTotalStore={$cartTotalStore}
                        deliveryOpenStore={$deliveryOpenStore}
                        publishConfigStore={$publishConfigStore}
                        on:confirmOrder={confirmOrderHandler}
                        on:close={closeScreen}>
                </CartOrderButton>
            </div>
        {/if}

    </div>
{/if}
